import { render, staticRenderFns } from "./external_group.vue?vue&type=template&id=5ae50c24"
import script from "./external_group.vue?vue&type=script&lang=js"
export * from "./external_group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports